<app-modal-shell
  [title]="title"
  [primaryDisabled]="!(editForm.valid && isFormChanged())"
  [errorMessage]="isErrorVisible ? errorMessage : null"
  (closed)="closePopup()"
  (submitted)="handleSubmit()"
>
  <form [formGroup]="editForm" class="form-body">
    <!-- Application Name -->
    <app-input
      [inputStyle]="'popup-form-field'"
      [label]="appNameLabel"
      [formCntlName]="applicationName"
      [placeholder]="appNamePlaceholder"
      [required]="true"
      [inputType]="'text'"
    >
    </app-input>
    @if (applicationName?.hasError('required') && applicationName?.touched) {
      <div class="mat-error-msg">
        <span>Application name is required.</span>
      </div>
    }
    @if (applicationName?.hasError('whitespace') && applicationName?.touched) {
      <div class="mat-error-msg">
        <span>Input cannot be just spaces.</span>
      </div>
    }

    <!-- Description -->
    <app-input
      [formCntlName]="description"
      [inputType]="'textarea'"
      [label]="descriptionLabel"
      [placeholder]="descriptionPlaceholder"
      [rows]="4"
      [maxLength]="descriptionMaxLength"
    ></app-input>
    <div class="char-counter">{{ description?.value?.length || 0 }} / {{ descriptionMaxLength }}</div>
    @if (description?.hasError('whitespace') && description?.touched) {
      <mat-error class="mat-error-msg" i18n>Input cannot be just spaces.</mat-error>
    }

    <!-- Application Version -->
    <app-input
      [inputStyle]="'popup-form-field'"
      [label]="appVersionLabel"
      [formCntlName]="version"
      [placeholder]="appVersionPlaceholder"
      [required]="true"
      [inputType]="'text'"
    >
    </app-input>
    @if (version?.hasError('required') && version?.touched) {
      <div class="mat-error-msg">
        <span i18n>Application Version is required.</span>
      </div>
    }
    @if (version?.hasError('pattern') && version?.touched) {
      <div class="mat-error-msg">
        <span i18n>Version must be in format X.Y.Z or W.X.Y.Z.</span>
      </div>
    }
    <!-- Container Name -->
    <app-input
      style="padding-bottom: 10px"
      [inputStyle]="'popup-form-field'"
      [label]="containerNameLabel"
      [formCntlName]="containerName"
      [placeholder]="containerNamePlaceholder"
      [required]="true"
      [inputType]="'text'"
      [maxLength]="containerNameMaxLength"
    >
    </app-input>
    <div class="char-counter">{{ containerName?.value?.length || 0 }} / {{ containerNameMaxLength }}</div>
    @if (containerName?.hasError('required') && containerName?.touched) {
      <div class="mat-error-msg">
        <span i18n>Container Name is required.</span>
      </div>
    }

    @if (containerName?.hasError('whitespace') && containerName?.touched) {
      <div class="mat-error-msg">
        <span>Input cannot be just spaces.</span>
      </div>
    }

    <!-- Inputs -->
    <app-input
      [inputStyle]="'popup-form-field'"
      [label]="inputTypeLabel"
      [subLabel]="inputTypeSubLabel"
      [formCntlName]="inputs"
      [required]="false"
      [inputType]="'text'"
    >
    </app-input>
    @if (inputs?.hasError('whitespace') && inputs?.touched) {
      <div class="mat-error-msg">
        <span>Input cannot be just spaces.</span>
      </div>
    }

    <!-- Org list -->
    <app-searchable-object-multi-select
      [inputStyle]="'popup-form-field'"
      [label]="selectOrgsLabel"
      formControlName="selectedOrgs"
      [placeholder]="selectOrgsPlaceholder"
      [options]="selectOrgsOptions"
      [display]="selectOrgsDisplayFn"
      [compare]="selectOrgsCompareFn"
      [multiple]="true"
    >
    </app-searchable-object-multi-select>

    <app-searchable-object-multi-select
      [inputStyle]="'popup-form-field'"
      [label]="dependsOnAppsLabel"
      formControlName="dependsOnAppVersions"
      [placeholder]="dependsOnAppsPlaceholder"
      [options]="dependsOnAppsSelectOptions"
      [display]="dependsOnAppsSelectDisplayFn"
      [compare]="dependsOnAppsSelectCompareFn"
      [multiple]="true"
    >
    </app-searchable-object-multi-select>

    <!-- Multi-run -->
    <div class="checkbox-field">
      <app-checkbox
        [label]="multiRunLabel"
        [isChecked]="multiRun.value ?? false"
        (checkedChange)="onMultiRunChange($event)"
      ></app-checkbox>
    </div>

    <!-- Plugin -->
    <div class="checkbox-field">
      <app-checkbox
        [label]="isPluginLabel"
        [isChecked]="isPlugin.value ?? false"
        (checkedChange)="onIsPluginChange($event)"
      ></app-checkbox>
    </div>
  </form>
</app-modal-shell>
